export default {
  otn: "OTN",
  max_width: null,
  max_length: null,

  idc_cover: false,
  cover_in_part: null,
  cover1_intern_id: null,
  cover2_intern_id: null,
  cover3_intern_id: null,
  cover4_intern_id: null,
  hs1_intern_id: null,
  hs2_intern_id: null,
  hs3_intern_id: null,
  hs4_intern_id: null,
  cover1_extern_id: null,
  cover2_extern_id: null,
  cover3_extern_id: null,
  cover4_extern_id: null,
  hs1_extern_id: null,
  hs2_extern_id: null,
  hs3_extern_id: null,
  hs4_extern_id: null,

  breastplate_module: {
    idc_breastplate: false,
    breastplate: null,
    breastplate_type: null,
    size: null,
    a: null,
    b: null,
    c: null,
    d: null,
    e: null,
    construction_type: null,
    idc_shoulder_socket: false,
    idc_adjustment_cebelor: false
  },
  shoulder_pad_position: null,
  shoulder_pad_size_trap: null,
  shoulder_pad_strap_matter: null,
  shoulder_pad_velcro: null,
  shoulder_pad_clip: null,
  shoulder_pad_cushion: null,
  shoulder_pad_workshop: null,
  thorax_position: null,
  thorax_size_trap: null,
  thorax_strap_matter: null,
  thorax_velcro: null,
  thorax_clip: null,
  thorax_cushion: null,
  thorax_workshop: null,
  chest_position: null,
  chest_size_trap: null,
  chest_strap_matter: null,
  chest_velcro: null,
  chest_clip: null,
  chest_cushion: null,
  chest_workshop: null,
  pelvis_position: null,
  pelvis_size_trap: null,
  pelvis_strap_matter: null,
  pelvis_velcro: null,
  pelvis_clip: null,
  pelvis_cushion: null,
  pelvis_workshop: null,
  femoral_position: null,
  femoral_size_trap: null,
  femoral_strap_matter: null,
  femoral_velcro: null,
  femoral_clip: null,
  femoral_cushion: null,
  femoral_workshop: null,
  tibial_position: null,
  tibial_size_trap: null,
  tibial_strap_matter: null,
  tibial_velcro: null,
  tibial_clip: null,
  tibial_cushion: null,
  tibial_workshop: null,
  foot_position: null,
  foot_size_trap: null,
  foot_strap_matter: null,
  foot_velcro: null,
  foot_clip: null,
  foot_cushion: null,
  foot_workshop: null,
  wrist_position: null,
  wrist_size_trap: null,
  wrist_strap_matter: null,
  wrist_velcro: null,
  wrist_clip: null,
  wrist_cushion: null,
  wrist_workshop: null,
  idc_anti_pressure_ulcers: false,
  matter: null,
  foam_under_otn: null,
  thickness: null,
  idc_coating: false,
  reinforcement: null,
  type_handle: "NONE",
  quantity: null,
  location: null,

  idc_bracket: false,
  bracket: null,
  bracket_type: null,
  type: null,
  other: null,
  bracket_location: null,
  serial_number: null,

  idc_corner_schema: false,
  triangle_a: null,
  triangle_b: null,
  triangle_c: null,
  embedded: null,

  idc_stop_dorsolumbar_hinge: false,
  comment_sewing: null,
  articles: []
};
